angular.module('impactx.logouttimer').controller('LogoutTimerCtrl', [
    '$scope',
    'LogoutTimerService',
    LogoutTimerCtrl]);

function LogoutTimerCtrl($scope, LogoutTimerService) {
    $scope.timeUntilLogout = LogoutTimerService.timeUntilLogoutFormatted;

}